const COOKIE_NAME = "RTVCustomer";
const MAX_DAYS_SINCE_LOGON = 200;

function parseDateString(dateStr: string): Date | null {
  // Format: dd.MM.yyyy HH.mm (e.g. "24.03.2026 15.14")
  const match = dateStr.match(/^(\d{2})\.(\d{2})\.(\d{4})\s(\d{2})\.(\d{2})$/);
  if (!match) return null;

  const [, day, month, year, hours, minutes] = match;
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
  );
}

function getCookieValue(name: string): string | null {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  if (!match) return null;
  try {
    return decodeURIComponent(match.split("=").slice(1).join("="));
  } catch {
    return null;
  }
}

export function hasLoggedOnRecently(): boolean {
  const cookieValue = getCookieValue(COOKIE_NAME);
  if (!cookieValue) return false;

  const params = new URLSearchParams(cookieValue);
  const lastLogon = params.get("lastLogon");
  if (!lastLogon) return false;

  const logonDate = parseDateString(lastLogon);
  if (!logonDate) return false;

  const daysSinceLogon =
    (Date.now() - logonDate.getTime()) / (1000 * 60 * 60 * 24);

  // Don't restrict on logon date for now, as we want to show the banner to all users while we test it out
  return true || daysSinceLogon <= MAX_DAYS_SINCE_LOGON;
}
